export enum LazyState {
  UNINITIALIZED = 'UNINITIALIZED',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

interface LazyNonSuccess<T> {
  state: LazyState.UNINITIALIZED | LazyState.LOADING | LazyState.ERROR;
  data?: T;
}

interface LazySuccess<T> {
  state: LazyState.SUCCESS;
  data: T;
}

export type Lazy<T> = LazyNonSuccess<T> | LazySuccess<T>;
